import React, { useState, useEffect } from "react";
import { Grid, IconButton } from "@material-ui/core";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import Heading from "../../../../StyledComponents/Heading/Heading";

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Delete } from "@material-ui/icons";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import { useSelector } from "react-redux";
const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});

function DebugTable({
  debugData,
  setDebugData,
  deletee,
  loading,
  status,
  selectedRole,
}) {
  const tableData = {
    id: 0,
    invoice_Id: 0,
    poNumber: "",
    vendorAmount: "",
    sapAmount: "",
    difference: "",
  };
  const classes = useStyles();

  const [calculation, setCalculation] = useState({
    vendorAmount: "",
    sapAmount: "",
    difference: "",
  });
  const role = useSelector((state) => state.Role);

  // function to compare selected PO records GRN Amount with Invoice Amount so we can proceed
  const checkBal = (tempArray) => {
    let t = 0;
    if (role.roleName === "IR") {
      let totalItems = tempArray.filter((data) => data.selected == true);
      t = totalItems
        .map((balance) => Number(balance?.inpuT_VAL || balance?.INPUT_VAL))
        .reduce((total, item) => total + item, 0);
    } else if (role.roleName === "IP") {
      let totalItems = tempArray;
      t = totalItems
        .map((balance) => Number(balance?.inpuT_VAL || balance?.INPUT_VAL))
        .reduce((total, item) => total + item, 0);
    }

    // setSelectedTotal(t);
  };

  const addInput = () => {
    setDebugData((debugData) => ({
      ...debugData,
      invoiceDebugData_List: [...debugData.invoiceDebugData_List, tableData],
    }));
  };

  const deleteInput = (index) => {
    const filteredData = debugData?.invoiceDebugData_List?.filter(
      (x, i) => i !== index
    );
    setDebugData((debugData) => ({
      ...debugData,
      invoiceDebugData_List: filteredData,
    }));
    checkBal(filteredData);
  };
  const changeHandler = (e, index) => {
    const { name, value } = e.target;

    if (name === "vendorAmount") {
      let tempArray = debugData.invoiceDebugData_List;
      const diff = Number(value) - Number(tempArray[index].sapAmount);

      tempArray[index] = {
        ...debugData.invoiceDebugData_List[index],
        [name]: value,
        difference: diff.toString(),
      };

      setDebugData((debugData) => ({
        ...debugData,
        invoiceDebugData_List: tempArray,
      }));

      let vendorAmount = 0;
      let sapAmount = 0;
      let difference = 0;
      for (let i = 0; i < tempArray?.length; i++) {
        const item = tempArray[i];
        vendorAmount = Number(vendorAmount) + Number(item.vendorAmount);
        sapAmount = Number(sapAmount) + Number(item.sapAmount);
        difference = Number(difference) + Number(item.difference);
      }
      setCalculation((calculation) => ({
        ...calculation,
        vendorAmount: vendorAmount,
        sapAmount: sapAmount,
        difference: difference,
      }));
      //   difference
    }
  };

  useEffect(() => {
    let vendorAmount = 0;
    let sapAmount = 0;
    let difference = 0;
    for (let i = 0; i < debugData.invoiceDebugData_List?.length; i++) {
      const item = debugData.invoiceDebugData_List[i];
      vendorAmount = Number(vendorAmount) + Number(item.vendorAmount);
      sapAmount = Number(sapAmount) + Number(item.sapAmount);
      difference = Number(difference) + Number(item.difference);
    }

    setCalculation((calculation) => ({
      ...calculation,
      vendorAmount: vendorAmount,
      sapAmount: sapAmount,
      difference: difference,
    }));
  }, []);
  return (
    <div>
      <Grid container style={{ margin: "8px 0px" }}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Heading title="DN Invoices Details" />
          <TableContainer
            className="scrollable"
            style={{
              maxHeight: "400px",
              minHeight: "100px",
              overflowY: "auto",
            }}
          >
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
            >
              <TableHead style={{ position: "sticky", top: 0, zIndex: "1" }}>
                <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Ship #
                  </TableCell>

                  {/* {!status === "SendToLogistics" || selectedRole === "IR" ? ( */}
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Amount Charged by vendor
                  </TableCell>
                  {/* ) : (
                    ""
                  )} */}

                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Amount as per SAP
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Difference
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {debugData?.invoiceDebugData_List?.length > 0 &&
                  debugData?.invoiceDebugData_List?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          <input
                            type="text"
                            size="small"
                            style={{
                              outline: "none",
                              border: "none",
                            }}
                            variant="standard"
                            name="poNumber"
                            disabled={true}
                            value={item?.poNumber}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        {/* {!status === "SendToLogistics" ||
                        selectedRole === "IR" ? ( */}
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            style={{
                              outline: "none",
                              border: "none",
                              width: "100%",
                              // borderBottom: "1px solid black",
                              backgroundColor:
                                item?.selected && "rgb(240,240,240)",
                            }}
                            variant="standard"
                            name="vendorAmount"
                            value={item?.vendorAmount}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        {/* ) : null} */}
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            style={{
                              outline: "none",
                              border: "none",
                            }}
                            variant="standard"
                            disabled={true}
                            name="sapAmount"
                            value={item?.sapAmount || item?.sapAmount || 0}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                        <TableCell>
                          <input
                            type="number"
                            size="small"
                            style={{
                              outline: "none",
                              border: "none",
                            }}
                            variant="standard"
                            disabled={true}
                            name="difference"
                            value={item?.difference || item?.difference}
                            onChange={(event) => changeHandler(event, index)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
              {loading && <TableSkeleton noOfColumns={13} noOfLines={3} />}
            </Table>
            {debugData?.invoiceDebugData_List?.length === 0 ? (
              <EmptyData />
            ) : (
              ""
            )}
          </TableContainer>
          {/* <Box display="flex" justifyContent={"flex-end"} mt={2}>
            <Button color="secondary" variant="contained" onClick={addInput}>
              Add New Row
            </Button>
          </Box> */}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Grid container style={{ marginLeft: "7px" }}>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              Vendor Amount:
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              {calculation?.vendorAmount}
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              SAP Amount:
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              {calculation?.sapAmount}
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              Difference:
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              {calculation?.difference}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default React.memo(DebugTable);
